import { FC, useEffect, useState } from 'react';
import { FormControl, Grid, InputLabel, MenuItem, Select } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SCUIButton } from '../../../../atomic/atoms';
import { SCUIGeneralDrawerHeader } from '../../../../atomic/molecules';
import Swal from 'sweetalert2';
import React from 'react';
import { CargoManagementQuery } from '../../../../services/query';
import { PostCheckoutCommand } from '../../../../services/command';
import { MFCD, mfcdCls } from '../../mobileFieldCargoDistribution.classes';

interface IProps {
    selectedRow?: any;
    setSelectedRow?: any;
    onClose?: any;
    filterInput?: any;
    companyList?: any;
    cityList?: any;
    listele?: any;
    searchReq?: any;
}
export const SCUIMobileDistributionAdd: FC<IProps> = ({
    onClose,
    companyList,
    selectedRow,
    cityList,
    listele,
    searchReq,
}) => {
    const { t } = useTranslation();
    const [companyId, setCompanyId] = React.useState(selectedRow.shippingCompanyId ? selectedRow.shippingCompanyId : 1);
    const [cityId, setCityId] = React.useState(selectedRow.cityId !== 0 ? selectedRow.cityId : 0);
    const [countyId, setCountyId] = React.useState(selectedRow.countyId !== 0 ? selectedRow.countyId : 0);
    const [countyList, setCountyList] = React.useState<any>([]);
    const [subCountyList, setSubCountyList] = React.useState<any>([]);
    const [subCountyId, setSubCountyId] = React.useState(selectedRow ? selectedRow.neighborhoodId : 0);
    const [countyName, setCountyName] = useState<any>(selectedRow ? selectedRow.countyName : '');
    const [subCountyName, setSubCountyName] = useState<any>(selectedRow ? selectedRow.subCountyName : '');
    const [week, setWeek] = React.useState<any>(
        selectedRow.weeklyDistributionDays !== 0 ? selectedRow.weeklyDistributionDays : 0
    );

    const GetCountyList = async () => {
        try {
            let params = {
                ParentAddressEntityId: cityId,
                countryId: 1,
            };
            if (cityId !== 0) {
                CargoManagementQuery.SubAddressEntities(params).then((res: any) => {
                    if (res.data.addressEntities) {
                        let parseData = res.data.addressEntities.map((item: any) => {
                            return {
                                value: item.addressEntityId,
                                text: item.name,
                            };
                        });
                        setCountyList(parseData && [...parseData]);
                    } else {
                        Swal.fire('Service Error', res.errorMessage, 'error');
                    }
                });
            }
        } catch (error: any) {
            Swal.fire('Error', error.toString(), 'error');
        }
    };

    const GetSubCountyList = async () => {
        try {
            let params = {
                ParentAddressEntityId: countyId,
                countryId: 1,
            };
            if (countyId !== 0) {
                CargoManagementQuery.SubAddressEntities(params).then((res: any) => {
                    if (res.data.addressEntities) {
                        let parseData = res.data.addressEntities.map((item: any) => {
                            return {
                                value: item.addressEntityId,
                                text: item.name,
                            };
                        });
                        setSubCountyList(parseData && [...parseData]);
                    } else {
                        Swal.fire('Service Error', res.errorMessage, 'error');
                    }
                });
            }
        } catch (error: any) {
            Swal.fire('Error', error.toString(), 'error');
        }
    };

    useEffect(() => {
        GetCountyList();
    }, [cityId]);

    useEffect(() => {
        GetSubCountyList();
    }, [countyId]);

    const UpsertMobileCargo = async () => {
        let mobileCargoDistribituon = {
            shippingCompanyId: companyId,
            addressEntityId: subCountyId,
            weeklyDistributionDays: week,
            cityName: cityList.find((city: any) => city.value === cityId)?.text,
            countyName: countyName,
            neighborhoodName: subCountyName,
        };
        PostCheckoutCommand.UpsertShippingCompanyServiceDistribution(mobileCargoDistribituon)
            .then((res: any) => {
                if (res.isSuccess === true) {
                    Swal.fire(t('general.added'), ' ', 'success');
                    listele(searchReq);
                    //  refresh();
                    onClose();
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            })
            .finally(() => {});
    };
    return (
        <form
            onSubmit={(e: any) => {
                e.preventDefault();
            }}
        >
            <div className={mfcdCls('commentFilterContainer', MFCD.addDrawerRoot)}>
                {
                    <Grid container spacing={2}>
                        <SCUIGeneralDrawerHeader
                            header={selectedRow?.length === 0 ? 'Kargo Firması Ekleme' : 'Kargo Firması Düzenleme'}
                            onClose={onClose}
                        />
                        <Grid
                            size={{
                                xs: 12,
                                md: 12,
                                lg: 12,
                                xl: 12
                            }}>
                            <Grid
                                className={MFCD.addDrawerFieldCompany}
                                style={{ marginTop: '1rem' }}
                                size={{
                                    xs: 12,
                                    md: 12,
                                    lg: 12,
                                    xl: 12
                                }}>
                                <InputLabel id="labelApp">{t('cargoFeeManagement.selectCargoCompany')}</InputLabel>
                                <Select
                                    className={MFCD.inputSelectAddDrawerCompany}
                                    label={t('cargoFeeManagement.selectCargoCompany')}
                                    labelId="labelApp"
                                    id="parentMenuLabel"
                                    value={companyId}
                                    defaultValue={selectedRow?.shippingCompanyId}
                                    onChange={(event) => {
                                        setCompanyId(Number(event.target.value));
                                    }}
                                    fullWidth
                                >
                                    {companyList &&
                                        companyList
                                            .filter((comp: any) => comp.value !== '-1')
                                            .map((comp: any) => (
                                                <MenuItem key={comp.value} id={comp.value} value={comp.value}>
                                                    {comp.text}
                                                </MenuItem>
                                            ))}
                                </Select>
                            </Grid>
                            <Grid
                                className={MFCD.addDrawerFieldCity}
                                style={{ marginTop: '1rem' }}
                                size={{
                                    xs: 12,
                                    md: 12,
                                    lg: 12,
                                    xl: 12
                                }}>
                                <InputLabel id="labelApp">{t('cargoManagement.selectCity')}</InputLabel>
                                <Select
                                    className={MFCD.inputSelectAddDrawerCity}
                                    label={t('cargoManagement.selectCity')}
                                    labelId="labelApp"
                                    id="parentMenuLabel"
                                    value={cityId}
                                    onChange={(event) => {
                                        setCityId(Number(event.target.value));
                                    }}
                                    fullWidth
                                >
                                    {cityList &&
                                        cityList
                                            .filter((city: any) => city.value !== '-1')
                                            .map((city: any) => (
                                                <MenuItem key={city.value} id={city.value} value={city.value}>
                                                    {city.text}
                                                </MenuItem>
                                            ))}
                                </Select>
                            </Grid>
                            <Grid
                                className={MFCD.addDrawerFieldCounty}
                                style={{ marginTop: '1rem' }}
                                size={{
                                    xs: 12,
                                    md: 12,
                                    lg: 12,
                                    xl: 12
                                }}>
                                <InputLabel id="labelApp">{'İlçe Seçiniz'}</InputLabel>
                                <Select
                                    className={MFCD.inputSelectAddDrawerCounty}
                                    label={'İlçe Seçiniz'}
                                    labelId="labelApp"
                                    id="parentMenuLabel"
                                    value={countyId}
                                    onChange={(event) => {
                                        setCountyId(Number(event.target.value));
                                        setCountyName(
                                            countyList.find((option: any) => option.value === event.target.value)?.text
                                        );
                                    }}
                                    fullWidth
                                >
                                    {countyList &&
                                        countyList
                                            .filter((county: any) => county.value !== '-1')
                                            .map((county: any) => (
                                                <MenuItem key={county.value} id={county.value} value={county.value}>
                                                    {county.text}
                                                </MenuItem>
                                            ))}
                                </Select>
                            </Grid>
                            <Grid
                                className={MFCD.addDrawerFieldNeighborhood}
                                style={{ marginTop: '1rem' }}
                                size={{
                                    xs: 12,
                                    md: 12,
                                    lg: 12,
                                    xl: 12
                                }}>
                                <InputLabel id="labelApp">{'Mahalle Seçiniz'}</InputLabel>
                                <Select
                                    className={MFCD.inputSelectAddDrawerNeighborhood}
                                    label={'Mahalle Seçiniz'}
                                    labelId="labelApp"
                                    id="parentMenuLabel"
                                    value={subCountyId}
                                    onChange={(event) => {
                                        setSubCountyId(Number(event.target.value));
                                        setSubCountyName(
                                            subCountyList.find((option: any) => option.value === event.target.value)
                                                ?.text
                                        );
                                    }}
                                    fullWidth
                                >
                                    {subCountyList &&
                                        subCountyList
                                            .filter((subCounty: any) => subCounty.value !== '-1')
                                            .map((subCounty: any) => (
                                                <MenuItem
                                                    key={subCounty.value}
                                                    id={subCounty.value}
                                                    value={subCounty.value}
                                                >
                                                    {subCounty.text}
                                                </MenuItem>
                                            ))}
                                </Select>
                            </Grid>
                            <Grid
                                className={MFCD.addDrawerFieldWeekly}
                                style={{ marginTop: '1rem' }}
                                size={{
                                    xs: 12,
                                    md: 12,
                                    lg: 12,
                                    xl: 12
                                }}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Haftalık değişim</InputLabel>
                                    <Select
                                        className={MFCD.inputSelectAddDrawerWeekly}
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={week}
                                        label="Haftalık değişim"
                                        onChange={(event) => {
                                            setWeek(Number(event.target.value));
                                        }}
                                        fullWidth
                                    >
                                        <MenuItem value={0}>0</MenuItem>
                                        <MenuItem value={1}>1</MenuItem>
                                        <MenuItem value={2}>2</MenuItem>
                                        <MenuItem value={3}>3</MenuItem>
                                        <MenuItem value={4}>4</MenuItem>
                                        <MenuItem value={5}>5</MenuItem>
                                        <MenuItem value={6}>6</MenuItem>
                                        <MenuItem value={7}>7 </MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Grid
                            style={{marginTop: '1rem',marginBottom: '20px'}}
                            size={{
                                xs: 12,
                                md: 12,
                                lg: 12,
                                xl: 12
                            }}>
                            <div className={MFCD.addDrawerActionsRow} style={{ display: 'flex', justifyContent: 'right' }}>
                            <SCUIButton
                                className={MFCD.inputButtonAddDrawerSubmit}
                                text={selectedRow?.length === 0 ? t('general.add') : t('general.update')}
                                type="primary"
                                sizeType="default"
                                buttonType="submit"
                                size={'m'}
                                style={{ width: '50%' }}
                                onClick={UpsertMobileCargo}
                            />
                            </div>
                        </Grid>
                    </Grid>
                }
            </div>
        </form>
    );
};
